<div
    class="flex flex-col md:grid md:grid-cols-2 xl:flex xl:flex-row xl:items-center"
    [ngClass]="{ 'bg-grey-100': greyBackground(), 'md:grid-flow-dense xl:flex-row-reverse': isReverse() }"
>
    <div class="relative h-full flex-grow xl:w-1/2" [ngClass]="isReverse() ? 'md:order-2 xl:order-none' : ''">
        <div>
            <ng-content select="[imageEdit]" />
            <ui-m000-c010-image
                class="block h-full"
                [classList]="imageStyle()"
                [image]="heroImage()"
                [priority]="true"
                [alt]="imageAlt()"
                cover
            />
            @if (badge(); as tag) {
                @let tagF = tag | footnotes;
                <ui-m040-c030-badge class="absolute right-24 top-12" [type]="'accent'">
                    <span [innerHTML]="tagF()"></span>
                </ui-m040-c030-badge>
            }
        </div>
        @if (imageCaption()) {
            <div class="flex flex-col gap-4 px-24 pb-4 lg:w-full lg:flex-row lg:justify-between lg:px-0">
                @if (imageCaption(); as imageCaption) {
                    <span class="leading-21 text-14 text-grey-400" [innerHTML]="imageCaption"></span>
                }
            </div>
        }
    </div>
    <div class="flex flex-col items-start justify-center p-24 text-black md:p-56 xl:w-1/2 xl:pr-[112px]">
        <div class="mb-8 text-31 leading-36 empty:hidden md:mb-4 md:text-34 md:leading-41">
            <ng-content select="[headline]" />
        </div>

        <div class="mt-4 text-22 leading-28 empty:hidden">
            <ng-content select="[subheadline]" />
        </div>

        <div class="w-full whitespace-pre-line">
            @if (strongText()) {
                <p class="font-headline text-16 font-medium leading-27">{{ strongText() }}</p>
            }
            <div class="text-16 leading-27 empty:hidden">
                <ng-content select="[text]" />
            </div>
            @if (list()) {
                <div class="flex">
                    <div class="mt-12 flex flex-col gap-12">
                        @for (item of list(); track $index) {
                            <div class="flex items-center gap-12">
                                <i class="text-[40px]" [ngClass]="[item.icon]"></i>
                                @let itemText = item.text | footnotes;
                                <p class="break-words text-16 leading-27" [innerHTML]="itemText()"></p>
                            </div>
                        }
                    </div>
                    <ng-content select="[bulletEdit]" />
                </div>
            }

            <div class="mt-24 flex flex-col gap-20 empty:hidden">
                <ng-content select="[cta]" />
            </div>
        </div>
    </div>
</div>
